export default "__VITE_ASSET__DonVrs5D__"